export const server = 'https://bits-restapi-produccion.azurewebsites.net/API';
export const serverCFDI = 'https://bits-timbrado-produccion.azurewebsites.net/API';

//export const server = 'http://localhost:4001/API';
//export const serverCFDI = 'http://localhost:5002/API';
